module.exports = "    _.--.,    \r\n  ,'      `,  \r\n /          \\ \r\n--------------\r\n|    -``'    |\r\n--------------\r\n \\          / \r\n  `.      ,'  \r\n    `''-'`"


//////////////////
// WEBPACK FOOTER
// ./src/res/wheelStraight.txt
// module id = 79
// module chunks = 0